<template>
  <div class="card" style="clear: both">
    <p class="title is-5 is-pulled-left mt-7 ml-7">Networks</p>
    <div class="mt-6 mr-6" style="float:right">
      <modal-opener-full
        :component="require('./NetworkModal').default"
        @reload="reloadComponent"
      >
        <button slot="trigger" class="button is-primary is-outlined mb-6">
          <b-icon icon="plus" style="height: 100%"></b-icon>
          <span>Add Network</span>
        </button>
      </modal-opener-full>
    </div>
    <div class="card-content">
      <b-table
        :loading="networks.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :current-page="networks.current_page"
        :per-page="networks.per_page"
        :total="networks.total"
        @page-change="(page) => networks.changePage(page)"
        class="is-middle"
        :data="networks.data"
        backend-sorting
        @sort="(field, direction) => networks.data.sort(field, direction)"
        :default-sort="['id', 'desc']"
      >
        <template slot-scope="{ row: network }" v-if="reload">
          <b-table-column label="SSID">{{
              network.ssid
            }}
          </b-table-column>

          <b-table-column label="IPV4">{{
              network.ipv4
            }}
          </b-table-column>

          <b-table-column width="5" centered>
            <button class="button is-danger is-outlined" @click="deleteNetwork" :value='network.id'>Remove</button>
          </b-table-column>
        </template>

        <template slot="empty">
          <empty-message></empty-message>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      networks: new window.PaginatedRemoteCollection(
        () => `/admin/api/wifi/vendors/${this.$route.params.id}/networks`
      ).load(),
      reload: true
    };
  },

  methods: {
    addNetwork() {
      if (this.form.ipv4.trim() !== '' && this.form.ssid.trim() !== '') {
        this.form.networks.push({
          'ipv4': this.form.ipv4,
          'ssid': this.form.ssid
        })
      }
    },
    addMagazine(magazine) {
      if (!this.form.magazines.includes(magazine.id)) {
        this.form.magazines.push(magazine.id)
      }
    },

    whenAdded() {
      this.$router.push(`/wifi-vendor`)
    },

    deleteNetwork(event) {

      let form = new window.Form();
      form.delete(
        `/admin/api/wifi/vendors/${this.$route.params.id}/networks/${event.target.value}`
      ).then(() => {
        this.$buefy.toast.open('Network removed')
        this.reloadComponent('network')
      })
      event.path[2].remove();
    },
    reloadComponent(value) {
      this.$emit('reload', value)
    }
  }
}
</script>
